import { Observable, Subscription } from 'rxjs';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { CurrencyPipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { BenefitsService } from '@benefits/services/benefits.service';
import { BenefitsDigest } from '@models/benefits/benefits-digest.model';
import { BenefitsDigestService } from '@reporting/services';

@Component({
    templateUrl: './benefits-digest.view.html',
    styleUrls: ['./benefits-digest.style.scss'],
    providers: [BenefitsService, CurrencyPipe],
})
export class BenefitsDigestView implements OnInit, OnDestroy {
    isLoading = true;
    showArchived = false;
    benefitsDigest$: Observable<BenefitsDigest[]>;
    isLoadingMore = false;
    private scrollSubscription: Subscription;

    constructor(
        private benefitsService: BenefitsService,
        private benefitsDigestService: BenefitsDigestService,
        private element: ElementRef,
        private scrollDispatcher: ScrollDispatcher,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.benefitsDigest$ = this.benefitsDigestService.benefitsDigest$;
    }

    ngOnInit(): void {
        this.loadBenefitsDigest();

        this.scrollSubscription = this.scrollDispatcher.ancestorScrolled(this.element).subscribe((scrollable) => {
            if (!scrollable) return;

            const pixelsNearTheBottom = 100;
            const offset = scrollable.measureScrollOffset('bottom');

            if (offset <= pixelsNearTheBottom) {
                this.loadMore();
            }
        });
    }

    ngOnDestroy(): void {
        this.scrollSubscription.unsubscribe();
    }

    private loadBenefitsDigest(): void {
        this.isLoading = true;
        this.benefitsDigestService.loadInitial(this.showArchived).then(() => {
            this.isLoading = false;
        });
    }

    private loadMore() {
        if (this.isLoadingMore || !this.benefitsDigestService.hasMore()) return;

        this.isLoadingMore = true;
        this.changeDetectorRef.detectChanges();
        this.benefitsDigestService.loadMore().then(() => {
            this.isLoadingMore = false;
        });
    }

    actionEvent(event: BenefitsDigest): void {
        this.isLoading = true;
        this.benefitsService.actionCompanyEvent(event.id).then(() => {
            this.benefitsDigestService.markItemAsActioned(event.id);
            this.isLoading = false;
        });
    }

    toggleArchived(): void {
        this.showArchived = !this.showArchived;
        this.loadBenefitsDigest();
    }

    formatValue(value: string | number): string | number {
        if (value === 1 || value === '1') {
            return 'Yes';
        }

        if (value === 0 || value === '0') {
            return 'No';
        }

        return value;
    }
}
